import { ReactNode } from 'react'
import { classes } from 'src/utils'

type Props = {
  children: ReactNode
  title?: string
  className?: string
}

export function Label(props: Props) {
  return (
    <span
      className={classes('text-sm font-medium text-slate-400', props.className)}
      title={props.title}
    >
      {props.children}
    </span>
  )
}
